'use client';
import { getExposureRecord, sendClickTrack } from '../../tempo_track';
import styles from './style.module.scss';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import pageSDK from '@/utils/goToPage';

interface HotArea {
  top: string;
  left: string;
  width: string;
  height: string;
  jumpData: {
    jumpType: string;
    jumpValue: any;
  };
}

interface HotInfo {
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  hotAreaList: HotArea[];
}

interface Props {
  moduleData: any;
  seo: any;
  localInfo: string;
  trackingId: string;
}

const getSkuIdFromUrl = (url: string): string | undefined => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    if (pathname.startsWith('/dp/')) {
      return pathname.match(/\/(\d+)$/)?.[1];
    }
  } catch (error) {}
};

export default function HotspotImage({ moduleData, seo, localInfo = '', trackingId }: Props) {
  const { dataBatch } = moduleData;

  // 热区排序函数 - 按从上到下、从左到右排序
  const sortHotAreas = (areas: HotArea[]): HotArea[] => {
    return [...areas].sort((a, b) => {
      const topA = parseFloat(a.top);
      const topB = parseFloat(b.top);
      const leftA = parseFloat(a.left);
      const leftB = parseFloat(b.left);

      // 先按top排序，再按left排序
      if (topA !== topB) {
        return topA - topB;
      }
      return leftA - leftB;
    });
  };
  // 处理热区点击事件
  const handleHotAreaClick = (hotArea: HotArea, index: number) => {
    const { jumpType, jumpValue } = hotArea.jumpData;
    // 上报点击事件
    const json_param = {
      moduleInstanceId: moduleData.moduleCode || '',
      page_id: trackingId,
      pos: moduleData.floorIndex || 0,
      img: hotInfo.imageUrl,
      index: [index],
      url: [jumpValue.link || jumpValue.pageCodeInfo?.jumpUrl || ''],
    };
    sendClickTrack.cms_TempoPage_HotzoneImage_click(json_param);

    if (jumpType === 'custom' && jumpValue?.link) {
      // 自定义链接跳转 - 使用pageSDK处理
      if (uaParse().isInJoybuyApp) {
        const skuId = getSkuIdFromUrl(jumpValue.link);
        if (skuId) {
          // 如果在joybuyApp里跳商详页，则直接唤起原生商详页
          return pageSDK.goToProduct({ skuId });
        } else {
          location.href = jumpValue.link;
        }
      } else {
        location.href = jumpValue.link;
      }
    } else if (jumpType === 'mini-home') {
      // 页面代码跳转 - 使用pageSDK处理
      if (jumpValue.pageCodeInfo?.jumpUrl) {
        location.href = jumpValue.pageCodeInfo?.jumpUrl;
      }
    } else if (jumpType === 'page-code') {
      // 页面代码跳转 - 使用pageSDK处理
      if (jumpValue.pageCodeInfo?.jumpUrl) {
        location.href = jumpValue.pageCodeInfo?.jumpUrl;
      }
    }
  };

  const exposureRecord = getExposureRecord(trackingId);
  // // 初始化热区数据
  // useEffect(() => {
  //   const hotInfo: HotInfo = dataBatch?.HotInfo;
  //   if (hotInfo && hotInfo.hotAreaList) {
  //     const sorted = sortHotAreas(hotInfo.hotAreaList);
  //     setSortedHotAreas(sorted);
  //   }
  // }, []);

  const hotInfo: HotInfo = dataBatch?.GroupHot[0]?.HotInfo;

  hotInfo.hotAreaList = sortHotAreas(hotInfo.hotAreaList);

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src={hotInfo.imageUrl} className={styles.image} />
        {/* 渲染热区 */}
        {hotInfo.hotAreaList.map((hotArea, index) => (
          <div
            key={index}
            className={styles.hotArea}
            style={{
              top: `calc(${hotArea.top} * 100%)`,
              left: `calc(${hotArea.left} * 100%)`,
              width: `calc(${hotArea.width} * 100%)`,
              height: `calc(${hotArea.height} * 100%)`,
            }}
            exptag={'exp|' + exposureRecord.cms_TempoPage_HotzoneImage_Expo}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            data-exptag-json-param={JSON.stringify({
              moduleInstanceId: moduleData.moduleCode || '',
              page_id: trackingId,
              pos: moduleData.floorIndex || 0,
              img: hotInfo.imageUrl,
              index: [index],
              url: [
                hotArea?.jumpData?.jumpValue?.link ||
                  hotArea?.jumpData?.jumpValue?.pageCodeInfo?.jumpUrl ||
                  '',
              ],
            })}
            onClick={() => handleHotAreaClick(hotArea, index)}
          />
        ))}
      </div>
    </div>
  );
}
